// ScoreTierLegendIndividual.js
import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const ScoreTierLegendIndividual = ({ redLight, yellowLight }) => {
    const circleStyle = (color, size = 12) => ({
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        display: 'inline-block',
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', columnGap: 5 }}>
            {/* Alto ajuste */}
            <div style={{ display: 'flex', alignItems: 'center', columnGap: 5 }}>
                <span style={circleStyle('#52c41a')} />
                <Text style={{ fontSize: 11 }}>
                    Resultados por encima de <Text strong style={{ fontSize: 11, color: '#52c41a' }}> {parseFloat(yellowLight)}% </Text>
                </Text>
            </div>

            {/* Medio ajuste */}
            <div style={{ display: 'flex', alignItems: 'center', columnGap: 5 }}>
                <span style={circleStyle('#faad14')} />
                <Text style={{ fontSize: 11 }}>
                    Resultados entre <Text strong style={{ fontSize: 11, color: '#faad14' }}> {parseFloat(redLight) + 0.1} al {parseFloat(yellowLight)}% </Text>
                </Text>
            </div>

            {/* Bajo ajuste */}
            <div style={{ display: 'flex', alignItems: 'center', columnGap: 5 }}>
                <span style={circleStyle('#ff4d4f')} />
                <Text style={{ fontSize: 11 }}>
                    Resultados por debajo del <Text strong style={{ fontSize: 11, color: '#ff4d4f' }}> {parseFloat(redLight)}% </Text>
                </Text>
            </div>
        </div>
    );
};

export default ScoreTierLegendIndividual;
